import React, { useState, useEffect } from 'react';
import SubbieLayout from '../layouts/SubbieLayout';
import { API_URL } from '../config';
import RoleLiveMap from '../components/RoleLiveMap';

// Subbie Live Map - shows only this subcontractor's own trucks/loads.
function SubbieLiveMap({ onLogout }) {
  const [user, setUser] = useState({});
  const [subbieId, setSubbieId] = useState(null);
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    setUser(userData);

    const resolveSubbie = async () => {
      let id = localStorage.getItem('subbieId');
      if (!id) {
        try {
          const res = await fetch(`${API_URL}/subcontractors?user_id=${userData.id}`);
          const data = await res.json();
          if (data.success && data.subcontractors && data.subcontractors.length > 0) {
            id = data.subcontractors[0].id;
            localStorage.setItem('subbieId', id);
            setCompanyName(data.subcontractors[0].company_name || '');
          }
        } catch (err) {
          console.error('Resolve subbie id error:', err);
        }
      } else {
        try {
          const res = await fetch(`${API_URL}/subcontractors/${id}`);
          const data = await res.json();
          if (data.success) setCompanyName(data.subcontractor?.company_name || '');
        } catch (err) {
          console.error('Fetch subbie name error:', err);
        }
      }
      if (id) setSubbieId(id);
    };

    if (userData.id) resolveSubbie();
  }, []);

  return (
    <SubbieLayout activeTab="livemap" onLogout={onLogout} user={user}>
      <RoleLiveMap
        filterBy="subbie"
        ownerId={subbieId}
        title={`Live Fleet${companyName ? ` — ${companyName}` : ''}`}
        subtitle="Your trucks in real time (auto-refreshes every 15s)"
      />
    </SubbieLayout>
  );
}

export default SubbieLiveMap;